export const palette = {
  alternate: {
    main: '#F9F6FF',
    light: '#F9F8F8',
    dark: '#E5EAF4',
  },
  cardShadow: 'rgba(23, 70, 161, .11)',
  type: 'light',
  primary: {
    main: '#10B7F2',
    contrastText: '#FFFFFF',
    light: '#F1FAFE',
  },
  secondary: {
    main: '#FFFFF',
    contrastText: '#002855',
  },
  text: {
    primary: '#141B22',
    light: 'rgba(71, 86, 112, 0.8)',
    secondary: '#64748B',
    disabled: '#CCC',
    highlight: '#FFF',
    success: '#1CA179',
    border: '#E5EAF4',
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  background: {
    main: '#F5F5F5',
    primary: '#43C2BD',
    paper: '#FFF',
    default: '#FFF',
    header: 'linear-gradient(to right, rgba(67, 185, 238, 0.5), rgba(207, 234, 246, 0.5), rgba(242, 251, 255, 1))',
    footer: '#F1FAFE',
    level2: '#f7f8fb',
    level1: '#FFF',
    tableHead: '#152435',
    tableSubhead: '#F1FAFE',
    arrow: '#10B7F2',
    tableAlternate: '#F8F8F8',
    alternate: '#E3F1FD',
    success: '#DBEFDC',
    error: '#FFEAEA',
    secondary: 'rgba(176, 224, 230, 0.4)',
    disclaimer: '#04212B'
  },
  verticalBar: {
    used: '#7BD6D0',
    unused: '#7BD6D01a',
    unlimited: '#C0C0C0',
  }
};
